import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyBoOFpytNjOVrPqvKh34UnZEPcxAM7Z5IU",
  authDomain: "bad-assort-auth.firebaseapp.com",
  projectId: "bad-assort-auth",
  storageBucket: "bad-assort-auth.firebasestorage.app",
  messagingSenderId: "761901074413",
  appId: "1:761901074413:web:57bb290df7c395187d09e4",
  measurementId: "G-0P61JX145L"
};

export const app = initializeApp(firebaseConfig);
